<template>
  <div class="admin-wrap">
    <div class="admin-actions">
      <details class="accounts">
        <summary class="btn ghost small" aria-label="Accounts">
          <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true">
            <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5z"/>
          </svg>
        </summary>
        <div class="panel card">
          <div class="row">
            <div class="muted small">Saved accounts</div>
            <div v-if="accounts.length === 0" class="muted small">None saved</div>
            <div v-for="(acc, idx) in accounts" :key="idx" class="account-item">
              <div class="label">{{ acc.label || acc.tenant || 'Account' }}</div>
              <div class="meta">{{ acc.tenant }}</div>
              <div class="actions">
                <button class="btn small" @click="switchTo(acc)">Switch</button>
                <button class="btn danger small" @click="removeAccount(idx)">Remove</button>
              </div>
            </div>
          </div>
          <div class="row actions">
            <button class="btn small" @click="saveCurrent">Save current</button>
            <button class="btn small" @click="gotoLogin">Add new…</button>
          </div>
        </div>
      </details>
      <button class="btn small ghost" @click="logout">Log out</button>
    </div>
    <router-view></router-view>
  </div>
  
</template>

<script>
import axios from 'axios'
import Auth from '../../api/auth'

export default {
  name: "Admin",
  data() {
    return {
      accounts: [],
      tenant: '',
    }
  },
  created() {
    this.loadAccounts()
    this.tenant = this.decodeTenant(localStorage.getItem('token'))
  },
  methods: {
    logout() {
      Auth.logout()
    },
    gotoLogin() {
      this.$router.push({ path: '/admin/login' })
    },
    loadAccounts() {
      try {
        const raw = localStorage.getItem('adminAccounts')
        this.accounts = raw ? JSON.parse(raw) : []
      } catch { this.accounts = [] }
    },
    persistAccounts() {
      localStorage.setItem('adminAccounts', JSON.stringify(this.accounts))
    },
    saveCurrent() {
      const token = localStorage.getItem('token')
      if (!token) return
      const tenant = this.decodeTenant(token)
      const label = window.prompt('Label for this account', tenant || 'Account')
      if (label === null) return
      this.accounts.push({ label, token, tenant })
      this.persistAccounts()
    },
    switchTo(acc) {
      if (!acc || !acc.token) return
      localStorage.setItem('token', acc.token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + acc.token
      this.tenant = acc.tenant || this.decodeTenant(acc.token)
      // Soft reload into admin root
      this.$router.push({ path: '/admin/choose' })
    },
    removeAccount(idx) {
      this.accounts.splice(idx, 1)
      this.persistAccounts()
    },
    decodeTenant(raw) {
      try {
        if (!raw) return ''
        const part = raw.split('.')[1]
        if (!part) return ''
        const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'))
        const payload = JSON.parse(decodeURIComponent(escape(json)))
        return payload.tenant || ''
      } catch { return '' }
    }
  }
};
</script>

<style scoped>
.admin-wrap { position: relative; }
.admin-actions { position: absolute; top: 12px; right: 12px; display: inline-flex; gap: 8px; z-index: 20; }
.btn { padding: 6px 10px; border: 1px solid #e5e7eb; background: #fff; border-radius: 6px; cursor: pointer; font-size: 0.9rem; }
.btn.small { padding: 4px 8px; font-size: 12px; }
.btn.ghost { background: #fff; border-color: #e5e7eb; }
.btn.danger { border-color: #fecaca; background: #fee2e2; color: #991b1b; }
.accounts { position: relative; }
.accounts > summary { list-style: none; }
.accounts > summary::marker, .accounts > summary::-webkit-details-marker { display: none; }
.accounts > summary .icon { display: inline-block; vertical-align: middle; color: #374151; }
.panel.card { position: absolute; right: 0; top: 100%; min-width: 300px; padding: 12px; background: #fff; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 6px 20px rgba(0,0,0,.08); }
.row { display: grid; gap: 8px; }
.row.actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 6px; }
.account-item { display: grid; grid-template-columns: 1fr auto; gap: 4px 8px; align-items: center; padding: 6px 0; border-bottom: 1px solid #f3f4f6; }
.account-item:last-child { border-bottom: 0; }
.account-item .label { font-weight: 600; color: #111827; }
.account-item .meta { font-size: 12px; color: #6b7280; }
.account-item .actions { display: flex; gap: 6px; }
.small { font-size: 12px; }
.muted { color: #6b7280; }
</style>
